<div class="modal-header">
	<h5>Contact us</h5>
	<button
		type="submit"
		class="close"
		(click)="dismiss()"
		aria-label="Close"
	></button>
</div>
<div class="modal-body">
	<app-feedback-form (submit)="close()"></app-feedback-form>
</div>
